module.exports = __webpack_public_path__ + "img/madrid_centro.cecd84bd.jpg";